module.exports = __webpack_public_path__ + "img/PLAY_IBIZA.20cd90b3.png";